const toMillis = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.seconds === "number") {
    return value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1000000);
  }
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.getTime();
  if (typeof value === "number") return Number.isFinite(value) ? value : null;

  const normalized = typeof value === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(value)
    ? value.replace(" ", "T")
    : value;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date.getTime();
};

export const mapAsistenciaSemaforo = (document) => {
  const data = document.data();
  const fechaEscalamiento = data.FechaEscalamientoAsignacion;
  const fechaEscalamientoISO = typeof fechaEscalamiento === "string"
    ? fechaEscalamiento.replace(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*([ap])\.?\s*m\.?$/i,
      (_, day, month, year, hour, minute, second, meridiem) =>
        `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${String((Number(hour) % 12) + (/p/i.test(meridiem) ? 12 : 0)).padStart(2, "0")}:${minute}:${second}`)
    : fechaEscalamiento;

  return {
    asistenciaID: document.id,
    estatusID: data.EstatusID,
    estatusFinalID: data.EstatusFinalID,
    campania: data.Campania,
    ubicacion: data.Origen,
    direccionOrigen: data.Origen,
    direccionDestino: data.Destino,
    servicio: data.Servicio,
    tipoServicio: data.TipoServicio,
    operador: data.Validador1,
    nombreOperador: data.Operador,
    nombre: data.AseguradoNombre,
    proveedor: data.ProveedorNombre,
    localCarretero: data.LocalCarretero,
    cuentaEspecialGNP: data.CuentaEspecialGNP,
    cuentaEspecialGS: data.CuentaEspecialGS,
    fechaLlamadaIniciada: toMillis(data.FechaLlamadaIniciada),
    fechaCapturaTerminada: toMillis(data.FechaCapturaTerminada),
    fechaAsignacion: toMillis(data.FechaAsignacion),
    fechaArribo: toMillis(data.FechaArribo),
    fechaContacto: toMillis(data.FechaContacto),
    fechaCita: toMillis(data.FechaCita),
    fechaTiempoLlegada: toMillis(data.FechaTiempoLlegada),
    fechaProveedorValidado: toMillis(data.FechaProveedorValidado),
    fechaIniciaAsignacion: toMillis(data.FechaIniciaAsignacion),
    fechaSugiereProveedor: toMillis(data.FechaSugiereProveedor),
    fechaInicioEnEsperaDeUsuario: toMillis(data.FechaInicioEnEsperaDeUsuario),
    fechaEscalamientoAsignacion: toMillis(fechaEscalamientoISO),
    fechaLiberaEscalamientoAsignacion: toMillis(data.FechaLiberaEscalamientoAsignacion),
    ultimoContacto: toMillis(data.UltimoContacto),
    usuarioIniciaAsignacion: data.UsuarioIniciaAsignacion,
    usuarioInicioAsignacionAsistencia: data.UsuarioInicioAsignacionAsistencia,
    usuarioIniciaSeguimiento: data.UsuarioIniciaSeguimiento,
    quienAsignaProveedor: data.QuienAsignaProveedor,
    esCita: data.EsCita,
    esConexion: data.EsConexion,
    esGnpApi: data.EsGnpApi,
    enEsperaUsuario: data.EnEsperaUsuario,
    tienePlaca: data.TienePlaca,
    urlPlaca: data.UrlPlaca,
    hasIncidenciaArribo: data.HasIncidenciaArribo,
    hasIncidenciaAsignacion: data.HasIncidenciaAsignacion,
    countPropuestas: data.CountPropuestas,
  };
};
